import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconArrowExpand: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.5 2V6C14.5 6.276 14.276 6.5 14 6.5C13.724 6.5 13.5 6.276 13.5 6V3.20736L9.68669 7.02067C9.58935 7.118 9.46133 7.16732 9.33333 7.16732C9.20533 7.16732 9.07731 7.11867 8.97998 7.02067C8.78465 6.82534 8.78465 6.50865 8.97998 6.31331L12.7933 2.5H10C9.724 2.5 9.5 2.276 9.5 2C9.5 1.724 9.724 1.5 10 1.5H14C14.0653 1.5 14.1301 1.5134 14.1914 1.53874C14.3134 1.5894 14.4107 1.68674 14.4621 1.80941C14.4867 1.87007 14.5 1.93467 14.5 2ZM6.31331 8.97998L2.5 12.7933V10C2.5 9.724 2.276 9.5 2 9.5C1.724 9.5 1.5 9.724 1.5 10V14C1.5 14.0653 1.5134 14.1301 1.53874 14.1914C1.5894 14.3134 1.68659 14.4106 1.80859 14.4613C1.86993 14.4866 1.93467 14.5 2 14.5H6C6.276 14.5 6.5 14.276 6.5 14C6.5 13.724 6.276 13.5 6 13.5H3.20736L7.02067 9.68669C7.216 9.49135 7.216 9.17466 7.02067 8.97933C6.82534 8.784 6.50865 8.78465 6.31331 8.97998Z" fill={color} />
  </svg>
);

export default IconArrowExpand;
